export class Widget {
    constructor(x, y, value, minW, minH) {
        this.points = [{ x, y }];
        this.width = 1;
        this.height = 1;
        this.x = x;
        this.y = y;
        this.value = value;
        this.minW = minW;
        this.minH = minH;
    }
    addPoint(x, y) {
        this.points.push({ x, y });
        this.x = Math.min(x, this.x);
        this.y = Math.min(y, this.y);
        this.width = Math.max(this.width, x - this.x + 1);
        this.height = Math.max(this.height, y - this.y + 1);
    }
    get() {
        const { width, height, x, y, value, minH, minW } = this;
        return { width, height, x, y, value, minH, minW };
    }
}
